import { FetchMappingGridTankTypeDisplayValue } from '../../../data/mappings';

const TankTypeComparator = (valueA, valueB) => {
    if (!valueA && !valueB) {
        return 0;
    }

    if (!valueA) {
        return -1;
    }

    if (!valueB) {
        return 1;
    }

    const compareValueA = FetchMappingGridTankTypeDisplayValue(valueA);
    const compareValueB = FetchMappingGridTankTypeDisplayValue(valueB);

    if (compareValueA > compareValueB) {
        return 1;
    }
    if (compareValueA < compareValueB) {
        return -1;
    }
    return 0;
};

export default TankTypeComparator;
